<template>
  <tr v-on:click="$emit('select', template)" :class="{ 'selected': selected == template }">
    <td class="template-preview-image">
      <img
        v-if="template.preview_url"
        class="preview-image"
        width="100"
        :src="template.preview_url"
        :data-test="`producer-savedGraphicsModal-templatePreview-${template._id}`"
        @mouseover="showPreview = true"
        @mouseleave="showPreview = false"
      >
      <div v-if="showPreview" class="hover-preview-image">
        <img class="preview-image-large" :src="template.preview_url" :data-test="`producer-savedGraphicsModal-templateHoverPreview-${template._id}`">
      </div>
    </td>

    <td class="template-details">
      <div class="meta-wrap">
        <div class="title" :data-test="`producer-savedGraphicsModal-templateName-${template._id}`">{{template.title}}</div>
      </div>
    </td>

    <td>{{template.created_time | formatTimestamp}}</td>
    <td>{{template.created_by.displayName}}</td>
  </tr>
</template>

<script lang="js">
module.exports = {
  props: ['template', 'selected'],

  data() {
    return {
      showPreview: false,
    };
  },
};
</script>
